var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleTable',{attrs:{"formclass":"Department/form","endpoint":"departments","aditionalColumns":_vm.headers,"hideDelete":""}},[[_c('h1',[_vm._v("Departamento")]),_c('v-divider',{staticClass:"mb-4"})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }